import React, { Component } from 'react';

import DataTable from '../Controls/DataTable/DataTable';
import { formatDate } from '@silverfort-nodelibs/common/utils/common';
import { EVENT_LEVEL, HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { bigNumberToText, httpGet, localTimezoneUtc } from '../utils';
import styles from './SystemNotifications.module.css';
import refreshIcon from '../common/Images/refresh.png';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import { Tooltip } from '@material-ui/core';

const severityColorMapper = {
    [EVENT_LEVEL.DEBUG.value]: {
        description: 'DEBUG',
        background: '#000'
    },
    [EVENT_LEVEL.INFO.value]: {
        description: 'INFO',
        background: '#188ded'
    },
    [EVENT_LEVEL.WARNING.value]: {
        description: 'WARNING',
        background: '#fb9e44'
    },
    [EVENT_LEVEL.ERROR.value]: {
        description: 'ERROR',
        background: '#f12047'
    }
};

class Notifications extends Component {
    constructor(props) {
        super(props);
        this.columns = [
            {
                header: `Time ${localTimezoneUtc()}`,
                accessor: 'start_timestamp',
                columnRenderer: (date) => {
                    const timestamp = formatDate(date, navigator, false).split(' ');
                    return (
                        <div className={styles.timeColumn}>
                            <div className={styles.topRow}>{timestamp[1]}</div>
                            <div className={styles.bottomRow}>{timestamp[0]}</div>
                        </div>
                    );
                },
                width: 160
            },
            {
                header: 'Level',
                accessor: 'level',
                columnRenderer: (severity) => {
                    const severityConfig = severityColorMapper[severity];
                    if (!severityConfig) {
                        console.warn(`Unknown notification severity level: ${severity} (type: ${typeof severity})`);
                    }
                    const config = severityConfig || severityColorMapper[EVENT_LEVEL.DEBUG.value];
                    return (
                        <div className="tag" style={{ background: config.background }}>
                            {config.description}
                        </div>
                    );
                },
                width: 120
            },
            {
                header: 'Component',
                accessor: 'source',
                width: 180,
                columnRenderer: (event_source) => (
                    <Tooltip title={event_source}>
                        <div className="overflow-ellipsis overflow-hidden">{event_source}</div>
                    </Tooltip>
                )
            },
            {
                header: 'Code',
                accessor: 'code',
                width: 80
            },
            {
                header: 'Description',
                accessor: 'description',
                width: 'auto',
                wrapText: true
            }
        ];

        if (props.systemMode === SYSTEM_MODES.SAAS) {
            this.columns = this.columns.filter((column) => column.header !== 'Component');
        }

        this.timer = null;
    }

    state = {
        alarms: [],
        initialLoading: true
    };

    componentDidMount() {
        this.loadData();
        this.timer = setInterval(() => this.loadData(), 5000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    refreshClickedHandler = () => {
        this.setState(
            {
                alarms: [],
                initialLoading: true
            },
            () => this.loadData()
        );
    };

    loadData = () => {
        httpGet('/systemEvents/alarms', { [HTTP_OPTIONS.HANDLE_ERRORS]: true }).then((response) => {
            if (response.data) {
                this.setState({ alarms: response.data, initialLoading: false });
            }
        });
    };

    render() {
        return (
            <div className="alarms-section">
                <div className="alarms-header">
                    <div className="left-side">
                        <div className="content-header">NOTIFICATIONS</div>
                        <span className="alarms-count">{`(${bigNumberToText(this.state.alarms.length)})`}</span>
                        <div className="refreshButton" onClick={this.refreshClickedHandler}>
                            <img alt="refresh" src={refreshIcon} />
                        </div>
                    </div>
                </div>
                <div className="alarms-table-container light-scrollbar">
                    <DataTable
                        columns={this.columns}
                        data={this.state.alarms}
                        loading={this.state.initialLoading}
                        noDataText="There are currently no notifications."
                    />
                </div>
            </div>
        );
    }
}

export default Notifications;
